import { useEffect } from 'react';

import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

import { useBudgetEditStart } from '../use-budget-edit-start';

import { Header } from './header';
import { PublisherForm } from './publisher-form';
import { ReachCampaignSection } from './reach-campaign-section';

export function ReachCampaignPage() {
  const {
    closeForm,
    selectedPublisher,
    hookForm,
    onFormSubmit,
    isSubmitting,
    isFormDirty,
  } = useEditCampaignContext();

  const { reset: resetForm, handleSubmit } = hookForm;

  useEffect(() => {
    if (selectedPublisher) {
      resetForm({
        starts_at: selectedPublisher.starts_at,
        end_at: selectedPublisher.end_at ?? null,
        budget: selectedPublisher.budget || null,
        budget_type: selectedPublisher.budget_type ?? undefined,
        expected_cpa: selectedPublisher.expected_cpa || null,
        target_applicants: null,
        expected_conversion: selectedPublisher.expected_conversion || null,
        target_hires: null,
      });
    }
  }, [selectedPublisher, resetForm]);
  useBudgetEditStart();

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <div className="flex flex-1 flex-col gap-6 overflow-auto">
        <Header
          isFormDirty={isFormDirty}
          isSaving={isSubmitting}
          onQuit={closeForm}
        />

        <div className="flex justify-center gap-6">
          <ReachCampaignSection />

          <PublisherForm />
        </div>
      </div>
    </form>
  );
}
